export enum MobileNavItem {
  Dashboard = 1,
  Investment,
  Home,
  Bank,
  Assets,
}

type TMobileNavStore = {
  data: MobileNavItem;
  setter: (data: MobileNavItem) => void;
};

export type { TMobileNavStore };
